import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROPAYLESS_LOGS(state, euroPaylessLogs) {
    state.cached = euroPaylessLogs
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEuroPaylessLogs(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_payless/logs/${query}`).then((response) => {
      const request = response.data
      context.commit('EUROPAYLESS_LOGS', request)
      return request
    })
  },
  fetchReportManagementExcelPayless(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/euro_payless/logs/get_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },

  fetchEuroPaylessLogsOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_payless/logs/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroPaylessLogsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },
}